"use client";

import { ComponentProps } from "react";
import { useIsShopsite } from "@context/DomainContext";
import { TextField as RadixTextField } from "@radix-ui/themes";
import { PropsWithChildren } from "react";
import { joinClassNames } from "@utils/helpers";

interface Props {
  shopsiteClasses?: string;
  whitelabelClasses?: string;
  sharedClasses?: string;
}

export default function TextInput({
  shopsiteClasses = "",
  whitelabelClasses = "",
  sharedClasses = "",
  size = "2",
  ref,
  ...restProps
}: ComponentProps<typeof RadixTextField.Root> & PropsWithChildren<Props>) {
  const isShopsite = useIsShopsite();

  if (isShopsite) {
    return (
      <input
        className={joinClassNames(
          "rounded-md border border-gray-300 px-2 py-1.5 text-black focus:outline-none focus:border-2 focus:py-[5px] focus:px-[7px] focus:border-indigo-500 disabled:text-gray-600 disabled:bg-gray-200 transition-colors duration-100 ease-in-out",
          // Error state driven by aria-invalid so the visual and programmatic
          // invalid states stay in sync (WCAG 3.3.1 / 4.1.2). Callers pass
          // aria-invalid + aria-describedby pointing at the error message.
          "aria-[invalid=true]:border-red-500 aria-[invalid=true]:focus:border-red-500",
          sharedClasses,
          shopsiteClasses
        )}
        ref={ref}
        {...restProps}
      />
    );
  }

  return (
    <RadixTextField.Root
      size={size}
      className={joinClassNames(sharedClasses, whitelabelClasses)}
      {...restProps}
      ref={ref}
    />
  );
}
